(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = window.scrollY || window.pageYOffset || 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.onFocusInHandler = this.onFocusIn.bind(this);
      this.onPageShowHandler = this.syncRestoredScroll.bind(this);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.header.addEventListener('focusin', this.onFocusInHandler);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('pageshow', this.onPageShowHandler);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.header.removeEventListener('focusin', this.onFocusInHandler);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('pageshow', this.onPageShowHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    syncRestoredScroll() {
      this.currentScrollTop = window.scrollY || window.pageYOffset || 0;
    }

    onFocusIn(event) {
      if (!this.header.contains(event.target)) return;
      if (!this.header.classList.contains('shopify-section-header-hidden')) return;
      requestAnimationFrame(this.reveal.bind(this));
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-browse-gifts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hf-browse-gifts')) {
    customElements.define(
      'hf-browse-gifts',
      class HfBrowseGifts extends HTMLElement {
        connectedCallback() {
          if (!this.initialized) {
            this.initialized = true;
            this.tabs = Array.from(this.querySelectorAll('[data-browse-tab]'));
            this.panels = Array.from(this.querySelectorAll('[data-browse-panel]'));
            this.rails = Array.from(this.querySelectorAll('[data-browse-rail]'));
            this.tabs.forEach((tab) => {
              tab.addEventListener('click', () => {
                this.selectTab(tab.dataset.browseTab, { source: 'user' });
              });
              tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
            });
            this.rails.forEach((rail) => {
              rail.addEventListener('scroll', () => this.updateRail(rail), { passive: true });
            });
            this.popstateListener = () => {
              this.selectTab(this.readTabFromUrl(), { source: 'history' });
            };
          }
          if (!this.popstateListening) {
            window.addEventListener('popstate', this.popstateListener);
            this.popstateListening = true;
          }
          this.selectTab(this.readTabFromUrl(), { source: 'initial' });
          this.startRailObserver();
          requestAnimationFrame(() => this.updateRails());
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.popstateListening) {
            window.removeEventListener('popstate', this.popstateListener);
            this.popstateListening = false;
          }
        }

        startRailObserver() {
          if (!('ResizeObserver' in window)) return;
          if (this.resizeObserver) this.resizeObserver.disconnect();
          this.resizeObserver = new ResizeObserver(() => this.updateRails());
          this.resizeObserver.observe(this);
        }

        updateRail(rail) {
          const hasOverflow = rail.scrollWidth - rail.clientWidth > 2;
          const atEnd = !hasOverflow || rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
          rail.dataset.hasOverflow = hasOverflow ? 'true' : 'false';
          rail.dataset.atEnd = atEnd ? 'true' : 'false';
        }

        updateRails() {
          this.rails.forEach((rail) => this.updateRail(rail));
        }

        readTabFromUrl() {
          const requestedKey = new URL(window.location.href).searchParams.get('browse');
          const defaultKey = this.tabs.some((tab) => tab.dataset.browseTab === this.dataset.defaultTab)
            ? this.dataset.defaultTab
            : this.tabs[0]?.dataset.browseTab;
          return this.tabs.some((tab) => tab.dataset.browseTab === requestedKey)
            ? requestedKey
            : defaultKey;
        }

        writeTabToUrl(key) {
          const url = new URL(window.location.href);
          url.searchParams.set('browse', key);
          window.history.pushState({}, '', url);
        }

        selectTab(key, { moveFocus = false, source = 'programmatic' } = {}) {
          const selectedTab = this.tabs.find((tab) => tab.dataset.browseTab === key);
          if (!selectedTab) return;
          const update = () => {
            this.tabs.forEach((tab) => {
              const active = tab.dataset.browseTab === key;
              tab.setAttribute('aria-selected', active ? 'true' : 'false');
              tab.tabIndex = active ? 0 : -1;
            });
            this.panels.forEach((panel) => {
              panel.hidden = panel.dataset.browsePanel !== key;
            });
          };

          update();
          requestAnimationFrame(() => this.updateRails());
          if (source === 'user') this.writeTabToUrl(key);
          if (moveFocus && selectedTab) selectedTab.focus();
        }

        onKeydown(event, tab) {
          const index = this.tabs.indexOf(tab);
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;
          if (nextIndex === index) return;
          event.preventDefault();
          this.selectTab(this.tabs[nextIndex].dataset.browseTab, {
            moveFocus: true,
            source: 'user',
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-product-shelves"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hf-product-shelves')) {
    customElements.define(
      'hf-product-shelves',
      class HfProductShelves extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';
          this.tabs = Array.from(this.querySelectorAll('[data-shelf-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-shelf-panel]'));
          this.tabList = this.querySelector('[role="tablist"]');
          this.tabCue = this.querySelector('.hf-shelves__tabs-cue');
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.selectTab(tab.dataset.shelfTab));
            tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
          });
          this.addEventListener('shopify:block:select', (event) => {
            const panel = event.target.closest('[data-shelf-panel]');
            if (panel) this.selectTab(panel.dataset.shelfPanel);
          });
          if (this.tabList && this.tabCue) {
            this.tabList.addEventListener('scroll', () => this.updateTabCue(), { passive: true });
            this.tabCueResizeObserver = new ResizeObserver(() => this.updateTabCue());
            this.tabCueResizeObserver.observe(this.tabList);
            requestAnimationFrame(() => this.updateTabCue());
          }
        }

        updateTabCue() {
          if (!this.tabList || !this.tabCue) return;
          const tolerance = 2;
          const maxScroll = Math.max(0, this.tabList.scrollWidth - this.tabList.clientWidth);
          const scrollLeft = Math.min(maxScroll, Math.max(0, this.tabList.scrollLeft));
          this.tabCue.hidden = maxScroll <= tolerance || maxScroll - scrollLeft <= tolerance;
        }

        selectTab(key, moveFocus = false) {
          const selectedTab = this.tabs.find((tab) => tab.dataset.shelfTab === key);
          let activePanel = null;
          this.tabs.forEach((tab) => {
            const active = tab.dataset.shelfTab === key;
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
          });
          this.panels.forEach((panel) => {
            const active = panel.dataset.shelfPanel === key;
            panel.hidden = !active;
            if (active) activePanel = panel;
          });
          if (selectedTab) {
            if (moveFocus) selectedTab.focus({ preventScroll: true });
            const tabList = selectedTab.closest('[role="tablist"]');
            if (tabList && tabList.scrollWidth > tabList.clientWidth) {
              const visibleStart = tabList.scrollLeft;
              const visibleEnd = visibleStart + tabList.clientWidth;
              const tabStart = selectedTab.offsetLeft;
              const tabEnd = tabStart + selectedTab.offsetWidth;
              let nextScrollLeft = visibleStart;
              if (tabStart < visibleStart) nextScrollLeft = tabStart;
              // Align a clipped tab to its own snap point. Calculating the
              // smallest possible delta can snap back to the previous tab,
              // especially on mobile where the tab list reserves room for
              // the directional cue.
              if (tabEnd > visibleEnd) nextScrollLeft = tabStart;
              requestAnimationFrame(() => {
                tabList.scrollTo({
                  left: nextScrollLeft,
                  behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
                });
              });
            }
          }
          if (activePanel) {
            this.hydratePanel(activePanel);
            requestAnimationFrame(() => {
              const slider = activePanel.querySelector('slider-component');
              if (slider && typeof slider.resetPages === 'function') slider.resetPages();
            });
          }
        }

        // Inactive tabs ship their cards inside an inert <template> so they cost
        // no layout or image decoding on first load. Move them into the rail the
        // first time the tab is opened; resetPages() then wires the slider.
        hydratePanel(panel) {
          const deferred = panel.querySelector('template[data-shelf-deferred]');
          if (!deferred) return;
          const rail = panel.querySelector('.hf-shelves__rail');
          if (!rail) return;
          rail.appendChild(deferred.content.cloneNode(true));
          deferred.remove();
        }

        onKeydown(event, tab) {
          const index = this.tabs.indexOf(tab);
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (nextIndex === index) return;
          this.selectTab(this.tabs[nextIndex].dataset.shelfTab, true);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
